export const SET_EXPANDED = 'SET_EXPANDED';
export const UPDATE = 'UPDATE';
